import { shallowEqual, useSelector } from 'react-redux';

const selectTranslationPractice = (state) => state.translationPractice;

export const useTranslationPractice = () =>
  useSelector(selectTranslationPractice, shallowEqual);
